import { LANGUAGE_CODES } from '../../lib/shared/languages';

const SUPPORT_EMAIL = 'support@boundly.com';
const TERMS_OF_USE_LINK = 'https://bound.ly/terms-of-use-boundly-non-us.html';
const PRIVACY_POLICY_LINK = 'https://bound.ly/privacy-policy-boundly-non-us.html';
const COOKIE_POLICY_LINK = 'https://bound.ly/cookie-policy-boundly.html';
const TERMS_OF_USE_LINK_DE = `https://bound.ly/${LANGUAGE_CODES.DE}/terms-of-use-boundly.html`;
const PRIVACY_POLICY_LINK_DE = `https://bound.ly/${LANGUAGE_CODES.DE}/privacy-policy-boundly.html`;
const COOKIE_POLICY_LINK_DE = `https://bound.ly/${LANGUAGE_CODES.DE}/cookie-policy-boundly.html`;

const LEGAL_LINKS_DE = {
    termsOfUse: TERMS_OF_USE_LINK_DE,
    privacyPolicy: PRIVACY_POLICY_LINK_DE,
    cookiePolicy: COOKIE_POLICY_LINK_DE
};

const LEGAL_LINK_LABELS_DE = {
    termsOfUse: 'AGB',
    privacyPolicy: 'Datenschutzerklärung',
    cookiePolicy: 'Cookie-Richtlinie'
};

export {
    SUPPORT_EMAIL,
    TERMS_OF_USE_LINK,
    PRIVACY_POLICY_LINK,
    COOKIE_POLICY_LINK,
    TERMS_OF_USE_LINK_DE,
    PRIVACY_POLICY_LINK_DE,
    COOKIE_POLICY_LINK_DE,
    LEGAL_LINKS_DE,
    LEGAL_LINK_LABELS_DE
};
